export default __webpack_public_path__ + "static/media/UndercurrentBTN.02cfcf2b.ttf";